 document.addEventListener("DOMContentLoaded", function () {

  const items = document.querySelectorAll(".menu-item");

  items.forEach(function(item){

    const button = item.querySelector(".menu-button");
    const panel = item.querySelector(".mega-panel");

    if(!panel) return;

    item.addEventListener("mouseenter", function(){
      panel.style.display = "grid";
    });

    item.addEventListener("mouseleave", function(){
      panel.style.display = "none";
    });

    button.addEventListener("click", function(e){
      e.preventDefault();

      if(panel.style.display=="grid"){
        panel.style.display="none";
      }else{
        panel.style.display="grid";
      }
    });

  });

});